export const DEFAULT_EASE = [0.4, 0, 0, 1];
export const DEFAULT_DURATION_S = 1;

/** Softer ease-out for large mosaic / carousel slides */
export const SMOOTH_EASE = [0.22, 1, 0.36, 1];
export const SMOOTH_DURATION_S = 1.4;
export const SMOOTH_EXIT_DURATION_S = 1.4;
